export const MISSION_TYPES_OPTIONS = [
  { label: 'All', value: 'ALL' },
  { label: 'Hand to hand', value: 'HANDTOHAND' },
  { label: 'Letterbox', value: 'LETTERBOX' },
]



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/Components/SettingsSection/container/options.js